export const INPUT_TYPES = {
  KEYBOARD: 'keyboard',
  GAMEPAD: 'gamepad',
  MOUSE: 'mouse',
  VOICE_COMMAND: 'voiceCommand',
} as const;

export type InputType = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES];
